import React, { createContext, useContext } from 'react'

import { useUserStore } from '../../entities/user/stores/user.store'

interface AuthContextType {
  isAuthenticated: boolean
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

interface AuthProvider {
  children: React.ReactNode
}

export const AuthProvider: React.FC<AuthProvider> = ({ children }) => {
  const user = useUserStore((state) => state.user)
  const isAuthenticated = Boolean(user?.token)

  return <AuthContext.Provider value={{ isAuthenticated }}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  return useContext(AuthContext)
}
